import React, { useState } from 'react';
import { Modal, Input, Button } from 'antd';

interface CompleteModalProps {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  handleMarkComplete: (orderId: string, internalReference: string) => void | Promise<void>;
  orderId: string;
}

const CompleteModal: React.FC<CompleteModalProps> = ({
  showModal,
  setShowModal,
  handleMarkComplete,
  orderId,
}) => {
  const [internalReference, setInternalReference] = useState("");

  const handleOk = async () => {
    handleMarkComplete(orderId, internalReference);
    setShowModal(false);
    setInternalReference("");
  };

  const handleCancel = () => {
    setShowModal(false);
    setInternalReference("");
  };

  return (
    <Modal
      title="Marcar como completado"
      open={showModal}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancelar
        </Button>,
        <Button
          key="submit"
          disabled={!internalReference}
          type="primary"
          onClick={handleOk}
        >
          Continuar
        </Button>,
      ]}
    >
      <p>Por favor, ingresa una referencia interna para completar la orden:</p>
      <Input
        value={internalReference}
        onChange={(e) => setInternalReference(e.target.value)}
        placeholder="Referencia"
      />
    </Modal>
  );
};

export default CompleteModal;
